/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */

/* eslint-disable react-hooks/exhaustive-deps */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import Logo from '../Logo';
import usageTracker from '../../lib/usageTracker';
import ErrorDetails from './ErrorDetails';
import { getDomain } from '../../selectors/Grader';
import SingleColumnLayout from '../layouts/SingleColumnLayout';
import { ThemedErrorPage } from '../../theming/components/ThemedErrorPage';
import Footer from '../footer/Footer';
export default (() => {
  const domain = useSelector(getDomain);
  useEffect(() => {
    if (domain) {
      usageTracker.logView('Error');
    }
  }, []);
  return /*#__PURE__*/_jsx(ThemedErrorPage, {
    children: /*#__PURE__*/_jsxs(SingleColumnLayout, {
      className: "error-page",
      children: [/*#__PURE__*/_jsx(UIIllustration, {
        name: "errors/map",
        width: "150px"
      }), /*#__PURE__*/_jsx(Logo, {}), /*#__PURE__*/_jsx("div", {
        className: "title",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "meta.title"
        })
      }), /*#__PURE__*/_jsx(ErrorDetails, {}), /*#__PURE__*/_jsx(Footer, {})]
    })
  });
});